import React, { useState, useRef, useEffect } from "react"
import { BookOpen } from "lucide-react"
import { Typography, Button, Badge, Input, message, useCRUDController, Row, Col, Card, Select, Divider } from "../../ui/ot"
import { ChartTotalHoldings } from './chart_total_holdings'
import { ChartGrowthRate } from "./chart_growth_rate"
import { ChartServiceBranch } from "./chart_service_branch"
import { ChartHoldingCategoryDistribution } from "./chart_holding_category_distribution"
import { ChartBranchHoldingTrend } from "./chart_branch_holding_trend"
import { TableHoldingTotal } from "./table_holding_total"
import dayjs from 'dayjs';
import { BadgeInfo } from 'lucide-react';

const basicFilterSetting = ["branchcode", "time", 'itemtype']

const TotalHoldings = ({
    filterSearchParams = [...basicFilterSetting]

}) => {
    const [searchParams, setSearchParams] = useState({
        item_type: null,
        branchcode: null,
        time_type: "year",
        start_time: filterSearchParams.includes("time") ? dayjs().startOf('year').format('YYYY-MM-DD') : null,
        end_time: filterSearchParams.includes("time") ? dayjs().endOf('year').format('YYYY-MM-DD') : null,
    })
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    const itemtypeController = useCRUDController({ apiRoute: "/koha/itemtypes" })
    useEffect(() => {
        libraryController.getData({})
        itemtypeController.getData({})
    }, []);
    return (<Row gutter={[4, 4]}>
        <Col span={24}>
            <Row align="middle">
                <Col>
                    <BookOpen className="h-5 w-5" />
                </Col>
                <Col>
                    <Typography.Title level={4}>
                        館藏總量統計
                    </Typography.Title>
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <Row gutter={[4, 4]}>
                <Col span={24}>
                    <Row >
                        {filterSearchParams.includes("time") ? <Col  >
                            <Row gutter={[4, 4]} align={"middle"}>
                                <Col>
                                    <Typography.P>
                                        建立日期:
                                    </Typography.P>
                                </Col>
                                <Col>
                                    <Input
                                        placeholder={"起"}
                                        type="date"
                                        value={searchParams?.start_time ? searchParams?.start_time : ""}
                                        onChange={(e) => {
                                            setSearchParams((pre) => {
                                                if (dayjs(e.target.value).isBefore(dayjs(pre?.end_time, "YYYY-MM-DD"))) {
                                                    return {
                                                        ...pre,
                                                        start_time: dayjs(e.target.value).format("YYYY-MM-DD"),
                                                    }
                                                }
                                                else {
                                                    return {
                                                        ...pre,
                                                        start_time: pre?.end_time,
                                                        end_time: e.target.value,
                                                    }
                                                }

                                            })
                                        }}
                                    />
                                </Col>
                                <Col>
                                    <Typography.Title level={4}>
                                        ~
                                    </Typography.Title>
                                </Col>
                                <Col>
                                    <Input
                                        placeholder={"訖"}
                                        type="date"
                                        value={searchParams?.end_time ? searchParams?.end_time : ""}
                                        onChange={(e) => {
                                            setSearchParams((pre) => {
                                                if ((dayjs(e.target.value)).isBefore(pre?.start_time)) {
                                                    return {
                                                        ...pre,
                                                        start_time: e.target.value,
                                                        end_time: pre?.start_time,
                                                    }
                                                }
                                                else {
                                                    return {
                                                        ...pre,
                                                        end_time: e.target.value,
                                                    }
                                                }

                                            })
                                        }}
                                    />
                                </Col>
                                {(searchParams.start_time || searchParams.end_time) &&
                                    <Col>
                                        <Button
                                            type={"icon"}
                                            onClick={() => {
                                                setSearchParams((pre) => {
                                                    return {
                                                        ...pre,
                                                        start_time: undefined,
                                                        end_time: undefined
                                                    }
                                                })
                                            }}>
                                            X
                                        </Button>
                                    </Col>
                                }
                            </Row>
                        </Col> : <></>}
                        {filterSearchParams.includes("branchcode") ? <Col>
                            <Row align={"middle"} gutter={[8, 8]}>
                                <Col>
                                    分館篩選：
                                </Col>
                                <Col>
                                    <Select
                                        allowClear={true}
                                        defaultValue={searchParams?.branchcode}
                                        value={searchParams?.branchcode}
                                        onChange={(value) => {
                                            setSearchParams((pre) => {
                                                return {
                                                    ...pre,
                                                    branchcode: value
                                                }
                                            })
                                        }}
                                        options={libraryController?.ResponseData?.map((option) => {
                                            return {
                                                label: `(${option?.branchcode})${option?.branchname}`,
                                                value: option?.branchcode,
                                            }
                                        })}
                                    >
                                    </Select>
                                </Col>
                            </Row>
                        </Col> : <></>}
                        {filterSearchParams.includes("itemtype") ? <Col>
                            <Row align={"middle"} gutter={[8, 8]}>
                                <Col>
                                    館藏分類篩選：
                                </Col>
                                <Col>
                                    <Select
                                        allowClear={true}
                                        defaultValue={searchParams?.itemtype}
                                        value={searchParams?.itemtype}
                                        onChange={(value) => {
                                            setSearchParams((pre) => {
                                                return {
                                                    ...pre,
                                                    item_type: value
                                                }
                                            })
                                        }}
                                        options={itemtypeController?.ResponseData?.map((option) => {
                                            return {
                                                label: `(${option?.itemtype})${option?.description}`,
                                                value: option?.itemtype,
                                            }
                                        })}
                                    >
                                    </Select>
                                </Col>
                            </Row>
                        </Col> : <></>}
                    </Row>
                </Col>
                <Col span={24}>
                    <Row align="middle" gutter={[4, 4]}>
                        <Col>
                            <BadgeInfo size={16} />
                        </Col>
                        <Col>
                            <Typography.P>
                                透過調整館藏建立日期、分館、館藏分類篩選，呈現館藏總量與成長率
                            </Typography.P>
                        </Col>
                    </Row>
                </Col>
                <Col xxl={16} xl={16} lg={16} md={16} sm={16} xs={24}>
                    <Row gutter={[8, 8]}>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                            <ChartTotalHoldings
                                propsBackgroundColor="bg-[#bbdefb]"
                                propsDataParams={{
                                    ...searchParams
                                }}
                            />
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                            <ChartGrowthRate
                                propsBackgroundColor="bg-[#bbdefb]"
                                propsDataParams={{
                                    ...searchParams
                                }}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                    <ChartServiceBranch
                        propsBackgroundColor="bg-[#c8e6c9]"

                    />
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <Row gutter={[4, 4]}>
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Card
                        title={"館藏類別分佈"}
                    >
                        <ChartHoldingCategoryDistribution />
                    </Card>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Card
                        title={"分館館藏趨勢"}
                    >
                        <ChartBranchHoldingTrend />
                    </Card>
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <Card
                title={"館藏統計資料"}
            >
                <TableHoldingTotal
                    filterSearchParams={["branchcode"]}
                />
            </Card>
        </Col>

    </Row>)
}
export { TotalHoldings }